import React from 'react';
import { FiTrash2, FiPlus, FiMinus } from 'react-icons/fi';
import { useApp } from '../context/AppContext';

const CartItem = ({ item }) => {
  const { addToCart, removeFromCart } = useApp();

  return (
    <div className="flex items-center gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
      
      {/* Image */}
      <img
        src={item.image}
        alt={item.name}
        className="w-20 h-20 object-cover rounded-lg"
      />

      {/* Infos */}
      <div className="flex-1">
        <h3 className="font-semibold text-gray-800">{item.name}</h3>
        <p className="text-sm text-gray-500">Taille : {item.size}</p>
        <p className="text-primary font-bold mt-1">
          {item.price.toLocaleString()} FCFA
        </p>
      </div>

      {/* Quantite */}
      <div className="flex items-center gap-2">
        <button
          onClick={() => removeFromCart(item._id, item.size)}
          className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition"
        >
          <FiMinus size={14} />
        </button>
        <span className="font-semibold w-6 text-center">{item.quantity}</span>
        <button
          onClick={() => addToCart(item, item.size)}
          className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition"
        >
          <FiPlus size={14} />
        </button>
      </div>

      {/* Total */}
      <div className="text-right min-w-24">
        <p className="font-bold text-gray-800">
          {(item.price * item.quantity).toLocaleString()} FCFA
        </p>
        <button
          onClick={() => removeFromCart(item._id, item.size)}
          className="text-red-500 hover:text-red-700 transition mt-1"
        >
          <FiTrash2 size={16} />
        </button>
      </div>
    </div>
  );
};

export default CartItem;